<template>
    <div>
        <h1 class="page-header">{{ $t('str.form.title.schedules.vigilant.patrol') }}</h1>
        <hr />

        <div class="row">
            <div v-if="isSuperAdminMaster" class="col-md-3 mb-3">
                <label class="form-label" for="accountField">{{ $t('str.register.guard.groups.account.field') }}</label>
                <select v-model="filters.account" @change="changeAccount" class="form-select" id="accountField">
                    <option value="">{{ $t('str.register.select.placeholder') }}</option>
                    <option v-for="account in accounts" :value="account._id" :key="account._id">
                        {{ account.name }}
                    </option>
                </select>
                <div class="invalid-feedback">{{ $t('str.register.guard.groups.account.required') }}</div>
            </div>
            <div v-if="role === 'SUPER_ADMIN_MASTER' || role === 'ADMIN' || role === 'MANAGER'" class="col-md-3 mb-3">
                <label class="form-label" for="clientField">{{ $t('str.register.guard.groups.client.field') }}</label>
                <select v-model="filters.client" @change="changeClient" class="form-select" id="clientField">
                    <option value="">{{ $t('str.register.select.placeholder') }}</option>
                    <option v-for="client in clients" :value="client._id" :key="client._id">
                        {{ client.name }}
                    </option>
                </select>
                <div class="invalid-feedback">{{ $t('str.register.guard.groups.client.required') }}</div>
            </div>
            <div class="col-md-3 mb-3">
                <label class="form-label" for="siteField">{{ $t('str.register.guard.groups.site.field') }}</label>
                <select v-model="filters.site" @change="changeSite" class="form-select" id="siteField">
                    <option value="">{{ $t('str.register.select.placeholder') }}</option>
                    <option v-for="site in sites" :value="site._id" :key="site._id">
                        {{ site.name }}
                    </option>
                </select>
                <div class="invalid-feedback">{{ $t('str.register.guard.groups.site.required') }}</div>
            </div>
            <div class="col-md-2 mb-3">
                <button @click="openCreateScheduleModal" class="btn bg-success mt-4">{{ $t('str.form.button.create.schedule') }}</button>
            </div>
            <div class="col-md-1 mb-3">
                <!-- // icone de refresh que chama o metodo getAppointments -->
                <button @click="getAppointments" class="btn bg-primary mt-4">
                    <i class="fas fa-sync-alt"></i>
                </button>
            </div>
        </div>

        <div v-if="calendarLoadError" class="alert alert-warning" role="alert">
            {{ $t('str.table.load.error') }}
            <button type="button" class="btn btn-sm btn-outline-dark ms-2" data-testid="calendar-retry" :disabled="isLoading" @click="getAppointments">
                {{ $t('str.table.load.retry') }}
            </button>
        </div>

        <CreateScheduleModal
            :newSchedule="newSchedule"
            :role="role"
            :selectedAppointment="selectedAppointment"
            :selectedDate="selectedDate"
            :accounts="accounts"
            :clients="clients"
            :sites="sites"
            :isSuperAdminMaster="isSuperAdminMaster"
        />
        <div
            v-show="!calendarLoadedScopeKey || calendarLoadedScopeKey === getCalendarScopeKey(filters)"
            data-testid="vigilant-calendar"
            :data-appointments-count="appointments.length"
            :data-sync-status="calendarSyncStatus"
        >
            <FullCalendar ref="calendar" :options="calendarOptions" />
        </div>

        <div v-if="isLoading" class="spinner-overlay">
            <b-spinner label="Carregando..." style="width: 2rem; height: 2rem" type="border" variant="primary" />
        </div>
        <notifications group="top-right" position="top right" :speed="1000" />
    </div>
</template>

<script>
import Vue from 'vue'

import Common from '../../../common/Common.vue'
import CreateScheduleModal from './CreateScheduleModal/CreateScheduleModal.vue'
import Controller from './CrtSchedule.vue'
import moment from 'moment'

import FullCalendar from '@fullcalendar/vue'

Vue.prototype.$registerEvent = new Vue()

export default {
    components: {
        FullCalendar,
        CreateScheduleModal,
    },
    data() {
        return {
            calendarOptions: {},
            appointments: [],
            accounts: [],
            clients: [],
            sites: [],
            isLoading: false,
            calendarLoadError: false,
            calendarLoadedScopeKey: null,
            calendarDisposed: false,
            clientsRequestId: 0,
            sitesRequestId: 0,
            selectedAppointment: {},
            newSchedule: {},
            isScopeReady: false,
            visibleCalendarRange: null,
            visibleRangeLoadedKey: null,
            visibleRangeInFlightKey: null,
            visibleRangeInFlightPromise: null,
            appointmentsRequestId: 0,
            calendarSyncStatus: 'idle',
            filters: {
                account: '',
                client: '',
                site: '',
                category: 'SECURITY_PATROL',
                startDate: moment().utc().format(),
                endDate: moment().endOf('month').utc().format(),
                isSortByStartDate: true,
                isFullCalendar: true,
            },
            role: '',
            isSuperAdminMaster: false,
            selectedDate: '',
        }
    },
    methods: Controller.methods,
    beforeDestroy() {
        this.calendarDisposed = true
        this.appointmentsRequestId += 1
        this.clientsRequestId += 1
        this.sitesRequestId += 1
    },
    created() {
        Controller.init(this)
        const state = this
        state.$registerEvent.$on('changeLanguage', function () {
            state.changeLanguage()
        })
        state.$registerEvent.$on('refreshSchedule', function () {
            if (state.filters?.account?.length > 0) {
                state.getAppointments()
            }
        })
        state.$registerEvent.$on('cancelAppointment', function () {
            Common.show(state, 'top-right', 'success', state.$t('str.form.archive.success'))
            state.$bvModal.hide('createScheduleModal')

            if (state.filters?.account?.length > 0) {
                state.getAppointments()
            }
        })
    },
}
</script>
<style scoped>
.spinner-overlay {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
